import trapApi from '@/api/trapApi';
import trapInspectionApi from '@/api/trapInspectionApi';
import trapInspectionRepo from '@/repos/trapInspectionRepo';

export default {
    async addEditTrapInspections(items) {
        await trapInspectionRepo.addUnsentTrapInspections(items);
        await trapInspectionRepo.addTrapInspections(items);
    },

    async fetchAndStoreLocations() {
        let locations = await trapApi.getLocations();
        
        // Clear table
        await trapInspectionRepo.clearTrapLocations();
        await trapInspectionRepo.addLocations(locations);
    },

    async fetchAndStoreTraps(plantID) {
        let traps = await trapApi.getTrapsByPlant(plantID);
        
        // Clear table
        await trapInspectionRepo.clearTraps();
        await trapInspectionRepo.addTraps(traps);
    },

    async fetchAndStoreTrapsForLocationByTrapID(trapID) {
        let traps = await trapApi.getTrapsForLocationByTrapID(trapID);

        // Clear table
        await trapInspectionRepo.clearTraps();
        await trapInspectionRepo.addTraps(traps);
    },

    async fetchAndStoreTrapInspections(plantID, fromDate, toDate) {
        let items = await trapInspectionApi.getTrapInspectionsByPlantAndDate(plantID, fromDate, toDate);

        // Clear table
        await trapInspectionRepo.clearTrapInspections();
        await trapInspectionRepo.addTrapInspections(items);
    },

    async fetchAndStoreTrapInspectionsByTrap(trapID, fromDate, toDate) {
        let items = await trapInspectionApi.getTrapInspectionsByTrapAndDate(trapID, fromDate, toDate);        
        await trapInspectionRepo.addTrapInspections(items);
    },

    async getTrapInspections() {
        return await trapInspectionRepo.getTrapInspections();
    },

    async getLocations() {
        return await trapInspectionRepo.getLocations();
    },

    async getTrapsByPlant(plantID) {
        return await trapInspectionRepo.getTrapsByPlant(plantID);
    },

    async getTrapsForLocationByTrapID(trapID) {
        return await trapInspectionRepo.getTrapsForLocationByTrapID(trapID);
    },

    async getUnsetTrapInspections() {
        return await trapInspectionRepo.getUnsetTrapInspections();
    },

    async getNextTrapInspectionID() {
        const unsent = await trapInspectionRepo.getUnsetTrapInspections();

        let newID = -1;

        unsent.forEach(item => {
            if (item.TrapInspectionID <= newID) {
                newID--;
            }
        });

        return newID;
    },

    async postUnSyncedData() {
        let unsentTrapInspections = await trapInspectionRepo.getUnsetTrapInspections();

        if (unsentTrapInspections.length > 0) {        
            let results = await trapInspectionApi.batchUpdate(unsentTrapInspections);
            
            await trapInspectionRepo.clearUnsentTrapInspections();
            await trapInspectionRepo.addTrapInspections(results);
        }
    }
}

